export const MAX_WEIGHT = 500;
const weightToIndex = (weight: number) => {
  const index = MAX_WEIGHT - weight;

  return index / 100;
};

export default weightToIndex;
